import React from 'react'
import { WorkSpaceUser } from '../../models'
import { Routes } from '../config/routes'
import { Redirect } from 'react-router-dom'
import { hasApplication } from '../../utils/applicationAccess'
import { APPLICATION_SLUGS } from '../../constants/applications'

interface ManageGuardProps {
    children: React.ReactNode
    workspaceUser?: WorkSpaceUser
}

export const ManageGuard = ({ children, workspaceUser }: ManageGuardProps) => {
    if (!workspaceUser) {
        return <Redirect to={Routes.error.permissionDenied} />
    }

    if (!hasApplication(workspaceUser, APPLICATION_SLUGS.EZMANAGE)) {
        return (
            <Redirect
                to={{
                    pathname: Routes.error.applicationAccessDenied,
                    state: { applicationSlug: APPLICATION_SLUGS.EZMANAGE },
                }}
            />
        )
    }

    return <div>{children}</div>
}
